import layout from './ChangelogPopup.html?raw';
import ComponentManager from '@/Management/ComponentManager';
import View from '@/Views/View';
import ChangelogPopupViewModel from '@/Components/ChangelogGrid/ChangelogPopupViewModel';

export default class ChangelogPopup extends View {

    private view: JQuery<HTMLElement>;

    public constructor(private readonly viewModel: ChangelogPopupViewModel, private readonly element?: JQuery<HTMLElement>) {
        super();
    }

    public getView(): JQuery<HTMLElement> {
        if (this.view != null) {
            return this.view;
        }

        this.view = this.applyBindings(this.element, this.viewModel, layout);
        return this.view;
    }

}

ComponentManager.setView('ChangelogPopup', ChangelogPopup, 'RADPresentation.HTMLClient.DefaultViewExtensions');